const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

export const api = {
  getBookings: async (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const url = qs ? `${API_URL}/bookings?${qs}` : `${API_URL}/bookings`;
    const res = await fetch(url);
    return res.json();
  },

  createBooking: async ({ name, phone, email, court, date, slots, receiptKey, consentData, consentTimestamp }) => {
    const res = await fetch(`${API_URL}/bookings`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, phone, email, court, date, slots, receiptKey, consentData, consentTimestamp }),
    });
    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.error || "Booking failed");
    }
    return res.json();
  },

  getUploadUrl: async (fileName, contentType) => {
    const res = await fetch(`${API_URL}/upload-url`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fileName, contentType }),
    });
    return res.json();
  },

  uploadReceipt: async (uploadUrl, file) => {
    await fetch(uploadUrl, {
      method: "PUT",
      headers: { "Content-Type": file.type },
      body: file,
    });
  },
  getPricing: async (courtId) => {
    const res = await fetch(`${API_URL}/pricing/${courtId}`);
    return res.json();
  },

  getCourtStatuses: async () => {
    const res = await fetch(`${API_URL}/courts/status`);
    return res.json();
  },

  getSettings: async () => {
    const res = await fetch(`${API_URL}/settings`);
    return res.json();
  },

  getClosures: async () => {
    const res = await fetch(`${API_URL}/closures`);
    return res.json();
  },
};
